import React from "react";
import { motion as m } from "framer-motion";

const container = {
  hidden: {},
  visible: (stagger) => ({
    transition: { staggerChildren: stagger, delayChildren: 0.05 },
  }),
};

const word = {
  hidden: { y: "110%", opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1] },
  },
};

/**
 * Word-by-word masked reveal for editorial headings.
 *
 * Accent spans are wrapped in asterisks and may cover more than one word:
 * "Design *with intent*" italicises both words.
 */
const tokenize = (text) =>
  String(text)
    .split(/(\*[^*]+\*)/g)
    .filter(Boolean)
    .flatMap((chunk) => {
      const accent = chunk.length > 2 && chunk.startsWith("*") && chunk.endsWith("*");
      const body = accent ? chunk.slice(1, -1) : chunk;
      return body
        .split(/\s+/)
        .filter(Boolean)
        .map((value) => ({ value: value.replace(/\*/g, ""), accent }));
    });

const SplitText = ({
  text = "",
  as = "h2",
  className = "",
  stagger = 0.05,
  once = true,
}) => {
  const Comp = m[as] || m.h2;
  const words = tokenize(text);

  return (
    <Comp
      className={`flex flex-wrap ${className}`}
      variants={container}
      custom={stagger}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount: 0.4 }}
    >
      {words.map((w, i) => (
        <span
          key={`${w.value}-${i}`}
          className="inline-block overflow-hidden pb-[0.12em] pr-[0.26em]"
        >
          <m.span
            variants={word}
            className={`inline-block ${
              w.accent ? "italic text-azure dark:text-electric" : ""
            }`}
          >
            {w.value}
          </m.span>
        </span>
      ))}
    </Comp>
  );
};

export default SplitText;
